import { Mousewheel } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/scss';
import 'app/styles/global/global.scss';
import './programs.scss';
import { slidesConfig } from '../config/SlidesConfig';

const Programs = () => (
  <section className="programs">
    <div className="programs__container container">
      <h2 className="programs__title section-title">Наши программы</h2>
    </div>
    <Swiper
      spaceBetween={20}
      slidesPerView="auto"
      centerInsufficientSlides
      breakpoints={{
        1024: {
          spaceBetween: 40,
        },
      }}
      mousewheel={{ enabled: true, releaseOnEdges: true }}
      modules={[Mousewheel]}
      centeredSlidesBounds
      className="programs__slider"
      wrapperClass="programs__items"
      id="programsSlider"
      setWrapperSize
    >
      {slidesConfig.map(slideItem => (
        <SwiperSlide key={slideItem.id} className="programs__item swiper-slide">
          <a href={slideItem.url} className="programs__link">
            <div className="programs__image">
              <img src={slideItem.src} alt={slideItem.programTitle} />
            </div>
            <div className="programs__content">
              <div className="programs__tags">
                {slideItem.tags.map(tag => (
                  <span key={`${slideItem.id}-${tag}-item`}>{tag}</span>
                ))}
              </div>
              <h3 className="programs__item-title">{slideItem.programTitle}</h3>
            </div>
          </a>
        </SwiperSlide>
      ))}
    </Swiper>
  </section>
);

export default Programs;
